import { RouteConfig } from 'vue-router';
import { mainRoute, InjectRoutes } from '@/router';
import { layoutHelper } from '@/helpers/LayoutHelper';

const routes: Array<RouteConfig> = [
  {
    path: 'RilievoIpsometrico',
    name: 'PiantaCampione',
    component: () => layoutHelper.isWeb ? import("./components/web/index-web.vue") : import("./components/mobile/index-mobile.vue"),
    meta: { title: 'Rilievo ipsometrico', showExpander: false, requireAuth: true }
  },
]


export default routes;